import React, { Component } from 'react'
import './ListGroups.css'
import { Link } from 'react-router-dom'

class ListGroups extends Component {
  render () {
    return (
      <div className={this.props.collapsed ? 'list-groups list-groups--collapsed' : 'list-groups'}>
        <h2>Tus quinielas</h2>
        {this.props.groups.map((group) => <Row {...group} key={group.id} />)}
      </div>
    )
  }
}

const Row = (props) => (
  <Link className={props.active ? 'list-groups__row' : 'list-groups__row list-groups__row--inactive'} to={'/g/' + props.id}>
    <div className='list-groups__image'>
      <img src={props.cover} alt={props.titulo} />
    </div>
    <div className='list-groups__info'>
      <div className='list-groups__info__col'>
        <div className='list-groups__name'>{props.titulo}</div>
        <div className='list-groups__mode'>{props.mode}</div>
      </div>
    </div>
  </Link>
)

export default ListGroups
